import {
  logFirebaseEvent,
  FirebaseEvents,
  FirebasePages,
  FirebaseModules,
} from '../../utilities/firebaseUtils';
import queryString from 'query-string';

export const logQuoteSubmission =
  (quoteAmount: number, orderNumber: string) => (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_SUBMISSION,
      FirebaseModules.FREIGHT,
      page,
      {
        quoteAmount,
        orderNumber,
      }
    );
  };

export const logQuoteCancellation =
  (orderNumber: string) => (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_CANCELLATION,
      FirebaseModules.FREIGHT,
      page,
      {
        orderNumber,
      }
    );
  };

export const logQuoteEdit =
  (quoteAmount: number, orderNumber: string) => (page: FirebasePages) => {
    logFirebaseEvent(FirebaseEvents.EDIT_QUOTE, FirebaseModules.FREIGHT, page, {
      orderNumber,
      quoteAmount,
    });
  };

export const logMyQuotesClick = () => {
  logFirebaseEvent(
    FirebaseEvents.MY_QUOTES_CLICK,
    FirebaseModules.FREIGHT,
    FirebasePages.LIST,
    {}
  );
};

export const logMyQuotesDetailClick = (orderNumber: string) => {
  logFirebaseEvent(
    FirebaseEvents.MY_QUOTES_DETAIL_CLICK,
    FirebaseModules.FREIGHT,
    FirebasePages.MY_QUOTES,
    {
      orderNumber,
    }
  );
};

export const logQuotingAnalytics = (fn: (page: FirebasePages) => void) => {
  const { pathname, search } = window.location;
  const { id, quotes } = queryString.parse(search);

  // drawer details
  if (id) {
    fn(FirebasePages.DETAILS);
  }
  // my quotes
  if (quotes && !id) {
    fn(FirebasePages.MY_QUOTES);
  }
  // list
  if (
    pathname.includes('findLoads') &&
    quotes === undefined &&
    id === undefined
  ) {
    fn(FirebasePages.LIST);
  }
  // myLanes
  if (pathname.includes('myLanes')) {
    fn(FirebasePages.MY_LANES);
  }
};

export const logQuoteCounter =
  (quoteAmount: number, orderNumber: string) => (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_COUNTER,
      FirebaseModules.FREIGHT,
      page,
      {
        quoteAmount,
        orderNumber,
      }
    );
  };

export const logQuoteDiscard =
  (orderNumber: string, quoteAmount: number | undefined) =>
  (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_DISCARD,
      FirebaseModules.FREIGHT,
      page,
      {
        orderNumber,
        quoteAmount,
      }
    );
  };

export const logQuoteDecline =
  (orderNumber: string, quoteAmount: number | undefined) =>
  (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_DECLINE,
      FirebaseModules.FREIGHT,
      page,
      {
        orderNumber,
        quoteAmount,
      }
    );
  };

export const logQuoteAccept =
  (orderNumber: string, quoteAmount: number | undefined) =>
  (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_ACCEPT,
      FirebaseModules.FREIGHT,
      page,
      {
        orderNumber,
        quoteAmount,
      }
    );
  };

export const logQuoteBookItNow =
  (quoteAmount: number, orderNumber: string) => (page: FirebasePages) => {
    logFirebaseEvent(
      FirebaseEvents.QUOTE_BOOK_IT_NOW,
      FirebaseModules.FREIGHT,
      page,
      {
        quoteAmount,
        orderNumber,
      }
    );
  };

export const logLoadManagement =
  (quoteAmount: number | undefined, orderNumber: string) =>
  (page: FirebasePages) => {
    logFirebaseEvent(FirebaseEvents.CLICK, FirebaseModules.FREIGHT, page, {
      orderNumber,
      description: 'Manage Load',
    });
  };
